// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GuZjg","importantInfo":"styles_importantInfo__22Rie"};